if (!customElements.get('measurement-range')) {
  class MeasurementRange extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.minNumber = this.querySelector('[data-measurement-number="min"]');
      this.maxNumber = this.querySelector('[data-measurement-number="max"]');
      this.minSlider = this.querySelector('[data-measurement-slider="min"]');
      this.maxSlider = this.querySelector('[data-measurement-slider="max"]');
      this.options = Array.from(this.querySelectorAll('[data-measurement-value]'));
      this.rangeMin = Number(this.dataset.rangeMin);
      this.rangeMax = Number(this.dataset.rangeMax);

      this.addEventListener('input', this.handleInput.bind(this));
      this.updateDisplay();
    }

    handleInput(event) {
      if (event.target === this.minSlider) this.minNumber.value = this.minSlider.value;
      if (event.target === this.maxSlider) this.maxNumber.value = this.maxSlider.value;
      if (event.target === this.minNumber) this.minSlider.value = this.validNumber(this.minNumber.value, this.rangeMin);
      if (event.target === this.maxNumber) this.maxSlider.value = this.validNumber(this.maxNumber.value, this.rangeMax);

      let min = Number(this.minSlider.value);
      let max = Number(this.maxSlider.value);

      if (min > max) {
        if (event.target === this.minSlider || event.target === this.minNumber) {
          max = min;
          this.maxSlider.value = max;
          this.maxNumber.value = max;
        } else {
          min = max;
          this.minSlider.value = min;
          this.minNumber.value = min;
        }
      }

      this.syncNativeOptions(min, max);
      this.updateDisplay();
    }

    validNumber(value, fallback) {
      const number = Number(value);
      if (!Number.isFinite(number)) return fallback;
      return Math.min(this.rangeMax, Math.max(this.rangeMin, number));
    }

    syncNativeOptions(min, max) {
      const fullRange = min <= this.rangeMin && max >= this.rangeMax;
      this.options.forEach((option) => {
        const value = Number(option.dataset.measurementValue);
        option.checked = !fullRange && value >= min && value <= max && !option.disabled;
      });
    }

    updateDisplay() {
      this.minNumber.value = this.format(this.minSlider.value);
      this.maxNumber.value = this.format(this.maxSlider.value);
    }

    format(value) {
      return Number(value).toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    }
  }

  customElements.define('measurement-range', MeasurementRange);
}
